/* -----------------------------------------------------------------
- Arena trans
----------------------------------------------------------------- */
export default {
    title: {
        list   : 'Orders',
        details: 'Order Details',
    },
};
